import React from 'react';
import './ProblemDescription.css';

const InspirationCarousel = () => {
    const mockInspirations = [
        { badge: 'documentação', text: 'Dificuldade em unificar solicitações de diferentes áreas (TI, Facilities, Jurídico, RH) em um único sistema de atendimento.' },
        { badge: 'atendimento', text: 'Grande volume de notas fiscais com fornecedores, sem controle claro de pagamento, prazos de renovação, multas e reajustes.' },
        { badge: 'documentação', text: 'Falta de visibilidade em tempo real sobre projetos e controle de alocações.' },
        { badge: 'atendimento', text: 'Processos descentralizados de solicitação, aprovação e reembolso de despesas corporativas, com baixa rastreabilidade.' },
        { badge: 'documentação', text: 'Atendimento fragmentado em e-mail, chat, WhatsApp e telefone, sem visão única do cliente.' },
        { badge: 'atendimento', text: 'Processos de admissão lentos, com muitos documentos manuais e falta de integração entre sistemas de RH globais.' },
        { badge: 'documentação', text: 'Controle manual de treinamentos obrigatórios e vencimento de certificações técnicas de colaboradores.' },
        { badge: 'atendimento', text: 'Dificuldade em captar, avaliar e acompanhar ideias de colaboradores de diferentes áreas.' },
        { badge: 'documentação', text: 'Baixa adesão a treinamentos corporativos obrigatórios (compliance, ESG, segurança, etc.).' }
    ];

    // Dividir em 3 arrays para as 3 linhas
    const line1 = mockInspirations.slice(0, 3);
    const line2 = mockInspirations.slice(3, 6);
    const line3 = mockInspirations.slice(6, 9);

    // Duplicar para scroll infinito
    const createDuplicatedLine = (line) => [...line, ...line, ...line];

    return (
        <div className="carousel-container">
            <div className="carousel-line">
                <div className="carousel-track carousel-track-1">
                    {createDuplicatedLine(line1).map((item, index) => (
                        <div key={index} className="carousel-card">
                            <span className={`card-badge badge-${item.badge}`}>
                                {item.badge}
                            </span>
                            <span className="carousel-card-text">
                                {item.text}
                            </span>
                        </div>
                    ))}
                </div>
            </div>
            
            <div className="carousel-line">
                <div className="carousel-track carousel-track-2">
                    {createDuplicatedLine(line2).map((item, index) => (
                        <div key={index} className="carousel-card">
                            <span className={`card-badge badge-${item.badge}`}>
                                {item.badge}
                            </span>
                            <span className="carousel-card-text">
                                {item.text}
                            </span>
                        </div>
                    ))}
                </div>
            </div>
            
            <div className="carousel-line">
                <div className="carousel-track carousel-track-3">
                    {createDuplicatedLine(line3).map((item, index) => (
                        <div key={index} className="carousel-card">
                            <span className={`card-badge badge-${item.badge}`}>
                                {item.badge}
                            </span>
                            <span className="carousel-card-text">
                                {item.text}
                            </span>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default InspirationCarousel;